import { render, staticRenderFns } from "./TopDescription.vue?vue&type=template&id=8536a852"
import script from "./TopDescription.vue?vue&type=script&lang=js"
export * from "./TopDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports